import React from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { InfoIcon } from '@components-library/Icons/iconsComponents';
import { keyMap } from '@locales/lokalise/keyMap';
import cn from 'classnames';
import styles from './styles.module.scss';

interface IPspOperationsNotificationProps {
  depositTabLocation?: boolean;
  text: string;
  depositFromAccount?: boolean;
}

export const PspOperationsNotification = ({
  depositTabLocation,
  text,
  depositFromAccount,
}: IPspOperationsNotificationProps) => {
  const { i18n } = useTranslation();

  return (
    <div className={cn('tabs__note', { deposits: depositTabLocation })}>
      <div className="tabs__text-wrapper">
        <InfoIcon size={16} />
        {text}
      </div>
      {depositTabLocation && !depositFromAccount && (
        <NavLink className={styles.pspNotificationLink} to="/member/profile">
          {i18n.t(keyMap.profileVerificationBtnTxt)}
        </NavLink>
      )}
    </div>
  );
};
